import React, { useState } from 'react';

const HelpPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('');
  const [openFAQ, setOpenFAQ] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const categories = [
    {
      id: 'getting-started',
      icon: 'fas fa-rocket',
      title: 'Başlarken',
      description: 'Hesap oluşturma ve ilk adımlar'
    },
    {
      id: 'matching',
      icon: 'fas fa-heart',
      title: 'Eşleşme',
      description: 'Nasıl eşleşir ve tanışırsınız'
    },
    {
      id: 'safety',
      icon: 'fas fa-shield-alt',
      title: 'Güvenlik',
      description: 'Güvenli tanışma rehberi'
    },
    {
      id: 'premium',
      icon: 'fas fa-crown',
      title: 'Premium',
      description: 'Premium özellikler ve ödeme'
    },
    {
      id: 'technical',
      icon: 'fas fa-cog',
      title: 'Teknik Destek',
      description: 'Uygulama sorunları ve çözümler'
    },
    {
      id: 'account',
      icon: 'fas fa-user',
      title: 'Hesap Yönetimi',
      description: 'Profil ve hesap ayarları'
    }
  ];

  const faqs = {
    'getting-started': [
      {
        id: 'how-it-works',
        question: 'SobCof nasıl çalışır?',
        answer: 'SobCof, gerçek kafelerde bulunan insanlarla tanışmanızı sağlar. Bir kafeye gittiğinizde, aynı kafede bulunan diğer SobCof kullanıcılarını görür ve beğenebilirsiniz. Karşılıklı beğeni olduğunda eşleşme gerçekleşir ve anonim sohbet başlar.'
      },
      {
        id: 'create-account',
        question: 'Hesap nasıl oluştururum?',
        answer: 'App Store\'dan SobCof uygulamasını indirin, telefon numaranızla kayıt olun, profil bilgilerinizi doldurun ve fotoğraflarınızı ekleyin. Hesabınız onaylandıktan sonra eşleşmeye başlayabilirsiniz.'
      }
    ],
    'matching': [
      {
        id: 'how-matching-works',
        question: 'Eşleşme nasıl çalışır?',
        answer: 'Aynı kafede bulunduğunuz kişileri görür ve beğenebilirsiniz. Karşı taraf da sizi beğenirse eşleşme gerçekleşir ve anonim sohbet başlar.'
      },
      {
        id: 'anonymous-chat',
        question: 'Anonim sohbet nedir?',
        answer: 'İlk eşleşmede profil bilgileriniz gizli kalır. Sohbet ederek birbirinizi tanıyın, uyumlu olduğunuzdan emin olduktan sonra profillerinizi paylaşabilirsiniz.'
      }
    ],
    'safety': [
      {
        id: 'safety-tips',
        question: 'Güvenli tanışma için ne yapmalıyım?',
        answer: 'İlk buluşmaları kalabalık yerlerde yapın, kişisel bilgilerinizi koruyun, şüpheli davranışları bildirin ve güvenlik kurallarımızı takip edin.'
      },
      {
        id: 'report-user',
        question: 'Bir kullanıcıyı nasıl şikayet ederim?',
        answer: 'Kullanıcı profilinde veya sohbet ekranında "Şikayet Et" butonuna tıklayın. Şikayetinizi detaylı olarak açıklayın, ekibimiz 24 saat içinde inceleyecektir.'
      }
    ],
    'premium': [
      {
        id: 'premium-features',
        question: 'Premium özellikler nelerdir?',
        answer: 'Sınırsız beğeni, sizi beğenenleri görme, gelişmiş filtreler, geri alma özelliği, genişletilmiş mesafe ayarları ve gizli mod.'
      },
      {
        id: 'premium-price',
        question: 'Premium üyelik ne kadar?',
        answer: 'Aylık 29.99 TL, yıllık 199.99 TL. İlk hafta ücretsiz deneme imkanı bulunmaktadır.'
      }
    ],
    'technical': [
      {
        id: 'app-not-working',
        question: 'Uygulama açılmıyor, ne yapmalıyım?',
        answer: 'Uygulamayı kapatıp tekrar açın, telefonunuzu yeniden başlatın, uygulama güncellemesi olup olmadığını kontrol edin.'
      },
      {
        id: 'location-not-working',
        question: 'Konum servisi çalışmıyor?',
        answer: 'Telefon ayarlarından SobCof için konum iznini kontrol edin, GPS\'in açık olduğundan emin olun.'
      }
    ],
    'account': [
      {
        id: 'change-photos',
        question: 'Fotoğraflarımı nasıl değiştirebilirim?',
        answer: 'Profil sayfasına gidin, fotoğraf alanına tıklayın ve yeni fotoğraflar ekleyin veya mevcut olanları silin.'
      },
      {
        id: 'delete-account',
        question: 'Hesabımı nasıl silebilirim?',
        answer: 'Ayarlar > Hesap > Hesabı Sil seçeneğini kullanın. Silinen hesaplar 30 gün boyunca kurtarılabilir.'
      }
    ]
  };

  const toggleFAQ = (faqId: string) => {
    setOpenFAQ(openFAQ === faqId ? null : faqId);
  };

  const handleCategoryClick = (categoryId: string) => {
    setActiveCategory(activeCategory === categoryId ? '' : categoryId);
    const element = document.getElementById(categoryId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="website-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-img" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/#features" className="nav-link">Özellikler</a>
            <a href="/#how-it-works" className="nav-link">Nasıl Çalışır</a>
            <a href="/#download" className="nav-link">İndir</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Help Content */}
      <section className="help-content">
        <div className="container">
          <div className="help-header">
            <h1>Yardım Merkezi</h1>
            <p className="help-subtitle">SobCof kullanımıyla ilgili tüm sorularınızın cevapları burada</p>
          </div>

          <div className="help-search">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Aradığınız konuyu yazın..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="button"><i className="fas fa-search"></i></button>
            </div>
          </div>

          <div className="help-categories">
            {categories.map((category) => (
              <div 
                key={category.id}
                className={`category-card ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
              >
                <div className="category-icon">
                  <i className={category.icon}></i>
                </div>
                <h3>{category.title}</h3>
                <p>{category.description}</p>
              </div>
            ))}
          </div>

          <div className="faq-section">
            <h2>Sık Sorulan Sorular</h2>
            
            {Object.entries(faqs).map(([categoryId, categoryFAQs]) => {
              const category = categories.find(c => c.id === categoryId);
              if (!category) return null;

              return (
                <div key={categoryId} className="faq-category" id={categoryId}>
                  <h3><i className={category.icon}></i> {category.title}</h3>
                  
                  {categoryFAQs.map((faq) => (
                    <div key={faq.id} className="faq-item">
                      <div 
                        className="faq-question"
                        onClick={() => toggleFAQ(faq.id)}
                      >
                        <h4>{faq.question}</h4>
                        <i className={`fas fa-chevron-${openFAQ === faq.id ? 'up' : 'down'}`}></i>
                      </div>
                      {openFAQ === faq.id && (
                        <div className="faq-answer">
                          <p>{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>

          <div className="help-contact">
            <div className="contact-card">
              <h3>Hala yardıma mı ihtiyacınız var?</h3>
              <p>Aradığınız cevabı bulamadıysanız, destek ekibimizle iletişime geçin.</p>
              <a href="/contact" className="contact-btn">
                <i className="fas fa-envelope"></i>
                İletişime Geç
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
                <li><a href="/#security">Güvenlik</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HelpPage;
